var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-link-v2',{class:[_vm.name, `${_vm.name}__link`, { over: _vm.active }],attrs:{"url":_vm.href},nativeOn:{"mouseover":function($event){return _vm.onCardHover(true)},"mouseleave":function($event){return _vm.onCardHover(false)}}},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('transition',{attrs:{"name":"fade"}},[((_vm.cms.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image`,attrs:{"src":_vm.cms.image.filename,"alt":_vm.cms.image.alt,"layout":_vm.layout}}):_vm._e()],1),_vm._v(" "),_c('div',{class:`${_vm.name}__content`},[(_vm.published)?_c('div',{class:`${_vm.name}__date`},[_vm._v("\n          "+_vm._s(_vm.$dateFns.format(new Date(_vm.published), 'dd / MMMM / yyyy'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.cms.eyebrow)?_c('a-eyebrow',{class:`${_vm.name}__eyebrow`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),(_vm.cms.heading)?_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"html-tag":"h4","cms":_vm.cms}}):_vm._e(),_vm._v(" "),_c('a-cta-v2',{class:`${_vm.name}__cta`,attrs:{"cms":{
            copy: 'Read more.',
            type: 'secondary',
            href: { url: _vm.href },
          }}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }